import { cn } from '../../../lib/styles';
import { Icon } from '../icon/icon.spark';
import type { BadgeProps, BadgeSize } from './types';

const SIZE_MAP: Record<BadgeSize, string> = {
  md: 'px-2 py-1',
  sm: 'px-1.5 py-0.5',
};

export function Badge(_props: BadgeProps) {
  const { variant = 'default', size = 'md', iconSize = 'xs', ...props } = _props;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-x-1 whitespace-nowrap rounded-lg border border-spark-border-contrast text-xs',
        SIZE_MAP[size],
        props.truncate ? 'h-fit min-w-0 max-w-full' : 'size-fit',
        {
          'bg-spark-surface-muted text-spark-text-primary': variant === 'default',
          'bg-spark-surface text-spark-text-primary': variant === 'white',
          'bg-spark-primary-soft text-spark-primary-accent': variant === 'primary',
          'bg-spark-tone-blue-bg text-spark-tone-blue-text': variant === 'blue',
          'bg-spark-tone-purple-bg text-spark-tone-purple-text': variant === 'purple',
          'bg-spark-tone-orange-bg text-spark-tone-orange-text': variant === 'orange',
          'bg-spark-tone-green-bg text-spark-tone-green-text': variant === 'green',
          'bg-spark-tone-yellow-bg text-spark-tone-yellow-text': variant === 'yellow',
          'bg-spark-tone-red-bg text-spark-tone-red-text': variant === 'red',
          'cursor-pointer': props.interactive,
        },
      )}
    >
      {props.icon && (
        <span aria-hidden className="inline-flex h-4 shrink-0 items-center">
          <Icon name={props.icon} size={iconSize} />
        </span>
      )}
      {props.truncate ? <span className="truncate">{props.children}</span> : props.children}
    </div>
  );
}
